import React from "react";

import { useAppContext } from "ui/hooks";

import { ErrorHandler } from "../..";

import styles from "./FullScreenLayout.module.scss";

export const FullScreenLayout: React.FC = ({ children }) => {
  const appInfo = useAppContext().appInfo;

  return (
    <div className={styles.appScreen}>
      <div className={styles.appName}>
        <h1>{appInfo.appName}</h1>
      </div>
      <ErrorHandler>{children}</ErrorHandler>
    </div>
  );
};
